export default "__VITE_ASSET__D02HEx0e__"